import CalendarView from '@/views/calendar/index.vue';
import ClientCreateView from '@/views/client/create/index.vue';
import ClientEditView from '@/views/client/edit/index.vue';
import ClientIndexView from '@/views/client/index/index.vue';
import ClientUserCreateView from '@/views/client-user/create/index.vue';
import ClientUserEditView from '@/views/client-user/edit/index.vue';
import ClientView from '@/views/client/view/index.vue';
import DashboardView from '@/views/dashboard/index.vue';
import DomainCreateView from '@/views/domain/create/index.vue';
import DomainEditView from '@/views/domain/edit/index.vue';
import DomainIndexView from '@/views/domain/index/index.vue';
import HomeView from '@/views/home/index.vue';
import InvoiceCreateView from '@/views/invoice/create/index.vue';
import InvoiceEditView from '@/views/invoice/edit/index.vue';
import InvoiceIndexView from '@/views/invoice/index/index.vue';
import InvoiceView from '@/views/invoice/view/index.vue';
import JobCreateView from '@/views/job/create/index.vue';
import JobEditView from '@/views/job/edit/index.vue';
import JobIndexView from '@/views/job/index/index.vue';
import JobView from '@/views/job/view/index.vue';
import MeetingIndexView from '@/views/meeting/index/index.vue';
import MeetingView from '@/views/meeting/view/index.vue';
import ServiceCreateView from '@/views/service/create/index.vue';
import ServiceEditView from '@/views/service/edit/index.vue';
import ServiceIndexView from '@/views/service/index/index.vue';
import TdsInvoiceView from '@/views/report/tds/invoice/index.vue';
import TechspecCreateView from '@/views/techspec/create/index.vue';
import TechspecEditView from '@/views/techspec/edit/index.vue';
import TechspecIndexView from '@/views/techspec/index/index.vue';
import TechspecView from '@/views/techspec/view/index.vue';
import TimesheetsView from '@/views/timesheets/index.vue';

const routes =
[
    {
        path: '/',
        name: 'home',
        component: HomeView,
        meta:
        {
            requiresAuth: false,
        },
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: DashboardView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/clients',
        name: 'client-index',
        component: ClientIndexView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/clients/new',
        name: 'client-create',
        component: ClientCreateView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/clients/:id',
        name: 'client-view',
        component: ClientView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/clients/:id/edit',
        name: 'client-edit',
        component: ClientEditView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/client_users/new',
        name: 'client-user-create',
        component: ClientUserCreateView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/client_users/:id/edit',
        name: 'client-user-edit',
        component: ClientUserEditView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/techspecs',
        name: 'techspec-index',
        component: TechspecIndexView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/techspecs/new',
        name: 'techspec-create',
        component: TechspecCreateView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/techspecs/:id',
        name: 'techspec-view',
        component: TechspecView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/techspecs/:id/edit',
        name: 'techspec-edit',
        component: TechspecEditView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/meetings',
        name: 'meeting-index',
        component: MeetingIndexView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/meetings/:id',
        name: 'meeting-view',
        component: MeetingView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/jobs',
        name: 'job-index',
        component: JobIndexView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/jobs/new',
        name: 'job-create',
        component: JobCreateView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/jobs/:id',
        name: 'job-view',
        component: JobView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/jobs/:id/edit',
        name: 'job-edit',
        component: JobEditView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/services',
        name: 'service-index',
        component: ServiceIndexView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/services/new',
        name: 'service-create',
        component: ServiceCreateView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/services/:id/edit',
        name: 'service-edit',
        component: ServiceEditView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/domains',
        name: 'domain-index',
        component: DomainIndexView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/domains/new',
        name: 'domain-create',
        component: DomainCreateView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/domains/:id/edit',
        name: 'domain-edit',
        component: DomainEditView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/invoices',
        name: 'invoice-index',
        component: InvoiceIndexView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/invoices/new',
        name: 'invoice-create',
        component: InvoiceCreateView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/invoices/:id',
        name: 'invoice-view',
        component: InvoiceView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/invoices/:id/edit',
        name: 'invoice-edit',
        component: InvoiceEditView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/calendar',
        name: 'calendar',
        component: CalendarView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/timesheets',
        name: 'timesheets',
        component: TimesheetsView,
        meta:
        {
            requiresAuth: true,
        },
    },
    {
        path: '/report/tds/invoice',
        name: 'tds-invoice-report',
        component: TdsInvoiceView,
        meta:
        {
            requiresAuth: true,
        },
    },
];

export default routes;